module.exports = __webpack_public_path__ + "cu.e0b76efbb437b7b983ef.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cu.svg
// module chunks = styles